"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallUs = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = __importDefault(require("styled-components"));
var styles_1 = require("../../styles");
// PENDING REAL EMAILS & PHONES for different support countries/regions
var TRANSLATIONS = {
    'en': {
        'any_question': 'Do you have any question?',
        'dont_worry': 'Don\'t worry about it,',
        'write_us': 'write us',
        'or_call': 'or call',
        'email': 'hello@hellomamma.co.uk',
        'phone_link': '44555',
        'phone': '+44 555',
    },
    'es': {
        'any_question': '¿Tienes preguntas?',
        'dont_worry': 'Non ti preoccupare,',
        'write_us': '¡escríbenos!',
        'or_call': 'o llama al',
        'email': 'hola@hellomamma.eu',
        'phone_link': '34933037615',
        'phone': '+34 93 303 76 15',
    },
    'fr': {
        'any_question': 'Des questions?',
        'dont_worry': 'Ne t\'en fais pas,',
        'write_us': 'écris nous !',
        'or_call': 'ou appelez le',
        'email': 'commandes@hellomamma.eu',
        'phone_link': '0033148904750',
        'phone': '+33 (0) 148 904 750',
    },
    'it': {
        'any_question': 'Hai dubbi?',
        'dont_worry': 'Non ti preoccupare,',
        'write_us': 'scrivici!',
        'or_call': 'o chiamaci al numero',
        'email': 'hola@hellomamma.eu',
        'phone_link': '34933037615',
        'phone': '+34 93 303 76 15',
    }
};
var P = styled_components_1.default.p(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n  font-family: ", ";\n  ", "\n  grid-column: 1 / span 4;\n  letter-spacing: -.23px;\n  margin-bottom: ", ";\n\n  ", "\n\n  a {\n    ", "\n   \n    &.phone {\n      ", "\n    }\n\n    &:not(.phone):hover { color: ", "; }\n  }\n\n  a.en { \n    ", "\n    text-decoration: underline;\n    \n      ", "\n  }\n\n  .phone {\n    ", "\n    color: ", ";\n    font-family: ", ";\n    display: inline-block;\n    margin-top: ", ";\n\n    ", "\n  }\n"], ["\n  color: ", ";\n  font-family: ", ";\n  ", "\n  grid-column: 1 / span 4;\n  letter-spacing: -.23px;\n  margin-bottom: ", ";\n\n  ", "\n\n  a {\n    ", "\n   \n    &.phone {\n      ", "\n    }\n\n    &:not(.phone):hover { color: ", "; }\n  }\n\n  a.en { \n    ", "\n    text-decoration: underline;\n    \n      ", "\n  }\n\n  .phone {\n    ", "\n    color: ", ";\n    font-family: ", ";\n    display: inline-block;\n    margin-top: ", ";\n\n    ", "\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.background;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.basier;
}, (0, styles_1.getP20_Mobile)(), (0, styles_1.getRelative)(50, 'mobile'), styles_1.mq.greaterThan('tablet')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    grid-column: 9 / span 4;\n    letter-spacing: -.3px;\n    margin-bottom: ", ";\n    "], ["\n    ", "\n    grid-column: 9 / span 4;\n    letter-spacing: -.3px;\n    margin-bottom: ", ";\n    "])), (0, styles_1.getP26_1)(), (0, styles_1.getRelative)(60, 'desktop')), (0, styles_1.createUnderline)({ color: 'background' }), (0, styles_1.createUnderline)({ color: 'orange', height: 3 }), function (_a) {
    var theme = _a.theme;
    return theme.colors.background;
}, (0, styles_1.createUnderline)({ reverse: true, color: 'white' }), styles_1.mq.greaterThan('tablet')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        text-decoration: none;\n      "], ["\n        text-decoration: none;\n      "]))), (0, styles_1.getP53)(), function (_a) {
    var theme = _a.theme;
    return theme.colors.orange;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.platform;
}, (0, styles_1.getRelative)(10, 'mobile'), styles_1.mq.greaterThan('tablet')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      margin-top: ", ";\n    "], ["\n      margin-top: ", ";\n    "])), (0, styles_1.getRelative)(15, 'desktop')));
var getCookies = function (name) {
    var e_1, _a;
    var nameEQ = "".concat(name, "=");
    if (typeof window === 'undefined')
        return null;
    var arrayOfCookies = document.cookie.split(';');
    try {
        for (var arrayOfCookies_1 = __values(arrayOfCookies), arrayOfCookies_1_1 = arrayOfCookies_1.next(); !arrayOfCookies_1_1.done; arrayOfCookies_1_1 = arrayOfCookies_1.next()) {
            var rawCookie = arrayOfCookies_1_1.value;
            var cookie = rawCookie;
            while (cookie.charAt(0) == ' ')
                cookie = cookie.substring(1, cookie.length);
            if (cookie.indexOf(nameEQ) == 0)
                return cookie.substring(nameEQ.length, cookie.length);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (arrayOfCookies_1_1 && !arrayOfCookies_1_1.done && (_a = arrayOfCookies_1.return)) _a.call(arrayOfCookies_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return null;
};
exports.CallUs = (0, react_1.memo)(function () {
    var locale = getCookies('NEXT_LOCALE') || 'es';
    return ((0, jsx_runtime_1.jsxs)(P, { children: [TRANSLATIONS[locale].any_question, " ", (0, jsx_runtime_1.jsx)("br", {}), TRANSLATIONS[locale].dont_worry, " ", (0, jsx_runtime_1.jsxs)("a", __assign({ href: "mailto:".concat(TRANSLATIONS[locale].email), className: "".concat(locale) }, { children: [TRANSLATIONS[locale].write_us, (0, jsx_runtime_1.jsx)("span", {})] }))] }));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
